import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'icon-location',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" [attr.width]="size()" [attr.height]="size()"
         viewBox="0 0 24 24">
      <path stroke="currentColor" stroke-width="2"
            d="M15.5 11c0 1.933-1.567 3.5-3.5 3.5S8.5 12.933 8.5 11s1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5Z" />
      <path stroke="currentColor" stroke-width="2"
            d="M12 2c4.8706 0 9 4.03298 9 8.9258 0 4.9707-4.1967 8.4589-8.073 10.8309-.2825.1595-.602.2433-.927.2433-.325
            0-.6445-.0838-.927-.2433C7.2039 19.3616 3 15.9137 3 10.9258 3 6.03298 7.12944 2 12 2Z" />
    </svg>
  `,
  styles: ``
})
export class IconLocationComponent {
  size: InputSignal<number> = input<number>(24);
}
